module.exports = __webpack_public_path__ + "static/img/R507.7bc4255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/oem/R507.jpg
// module id = Gay6
// module chunks = 1